import { createStyles, Theme } from '@material-ui/core';
import { styleColors } from 'src/main.style';

export const EmailIntegrationSettingsStyle = (theme: Theme) => createStyles({
  heading: { fontSize: '24px', margin: 0 },
  subheading: { fontSize: '18px', margin: 0 },
  text: { margin: 0, lineHeight: 1.6 },
  integration: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    minWidth: 0,
  },
  addressBox: {
    border: `1px solid ${styleColors.outlineBlack23}`,
    borderRadius: '12px',
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  address: {
    flex: '1 1 180px',
    minWidth: 0,
    margin: 0,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    userSelect: 'text',
    lineHeight: 1.6,
  },
  copyActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    flexBasis: '100%',
    '& > *': { minHeight: '48px' },
    [theme.breakpoints.down('xs')]: {
      '& > *': { width: '100%' },
    },
  },
  loading: { display: 'flex', alignItems: 'center', gap: theme.spacing(2) },
  actions: { display: 'flex' },
  error: { color: theme.palette.error.main, margin: 0 },
});



// WEBPACK FOOTER //
// ./src/components/integrations/email/EmailIntegrationSettings.style.ts